module.exports = __webpack_public_path__ + "img/石膏.37f073df.jpg";